import smokeTexture from '../assets/images/smoke.gif';

const StyledText = ({ word, sizeClass = 'text-[clamp(75px,23vw,180px)]' }) => (
  <span className="relative inline-block leading-none">
    {/* Black outline layer - smoother with filter */}
    <span
      aria-hidden
      className={`absolute inset-0 font-mak font-bold text-transparent ${sizeClass} select-none`}
      style={{
        textShadow: `
          -2px -2px 0 black,
          2px -2px 0 black,
          -2px 2px 0 black,
          2px 2px 0 black,
          -1px -1px 0 black,
          1px -1px 0 black,
          -1px 1px 0 black,
          1px 1px 0 black,
          -2px 0 0 black,
          2px 0 0 black,
          0 -2px 0 black,
          0 2px 0 black,
          -1px 0 0 black,
          1px 0 0 black,
          0 -1px 0 black,
          0 1px 0 black
        `,
        lineHeight: 1.05,
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        filter: 'blur(0.3px)',
        zIndex: 1,
      }}
    >
      {word}
    </span>
    
    {/* Invisible base layer to maintain size */}
    <span
      className={`relative font-mak font-bold text-transparent ${sizeClass}`}
      style={{
        lineHeight: 1.05,
        visibility: 'hidden',
      }}
    >
      {word}
    </span>
    
    {/* Smoke texture layer */}
    <span
      className={`absolute inset-0 font-mak font-bold text-transparent ${sizeClass}`}
      style={{
        backgroundImage: `url(${smokeTexture})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        lineHeight: 1.05,
        WebkitTransform: "translateZ(0)",
        transform: "translateZ(0)",
        WebkitFontSmoothing: "antialiased",
        willChange: "transform",
        isolation: "isolate",
        zIndex: 2,
      }}
    >
      {word}
    </span>
    
    {/* Blue overlay layer - MUST BE ON TOP */}
    <span
      className={`absolute inset-0 font-mak font-bold ${sizeClass}`}
      style={{
        color: "rgba(20, 40, 240, 0.9)",
        lineHeight: 1.05,
        WebkitBackgroundClip: "text",
        backgroundClip: "text",
        WebkitTransform: "translateZ(0)",
        transform: "translateZ(0)",
        zIndex: 3,
        mixBlendMode: "normal",
        opacity: 0.5,
      }}
    >
      {word}
    </span>
  </span>
);

export default StyledText;